import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ra_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.match(/\/login$/)) {
      localStorage.removeItem("ra_token");
      localStorage.removeItem("ra_user");
      // If we're inside a /portal/:slug route, send them to the portal login (not admin)
      const portalMatch = window.location.pathname.match(/^\/portal\/([^/]+)/);
      if (portalMatch) {
        window.location.href = `/portal/${portalMatch[1]}/login`;
      } else {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
